import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, EMPTY, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../auth/auth.service';
import { catchError, filter, finalize, switchMap, take, tap } from 'rxjs/operators';




@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private instanceId: any;

  constructor(private authService: AuthenticationService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = this.addToken(request);

    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          // Access the response headers
          const headers = event.headers;
          // this.sharedService.apiVersion = headers.get('x-api-version');
          // this.sharedService.buildVersion = headers.get('x-api-build-number');
        }
      }),
      catchError(error => {
        const isLoginRequest = request.url.includes('/login');
        const hasRefreshToken = !!this.authService.currentUserValue?.refresh_token;

        if (error.status === 401 && (isLoginRequest || !hasRefreshToken)) {
          return throwError(error);
        }

        if (error.status === 401) {
          if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return this.authService.refreshToken().pipe(
              switchMap(() => {
                request = this.addToken(request);
                // this.alert.success_alert("Dear User, token is refreshed.if your experiencing the high loading time please refresh the screen.")
                return next.handle(request);
              }),
              catchError((err) => {
                this.isRefreshing = false;
                return this.handleError(err);
              }),
              finalize(() => {
                this.isRefreshing = false;
              })
            );
          } else {
            return this.refreshTokenSubject.pipe(
              filter(result => result !== null),
              take(1),
              switchMap(() => {
                request = this.addToken(request);
                return next.handle(request);
              })
            );
          }
        }
        return throwError(error);
      })
    );
  }

  private addToken(request: HttpRequest<any>): HttpRequest<any> {
    this.instanceId = JSON.parse(sessionStorage.getItem('instanceConfig'))?.InstanceModel?.idinstance;

    let user = this.authService.currentUserValue
    const token = this.authService.currentUserValue?.token;
    if (user && token) {
      const urlWithInstance = request.url.includes('?')
        ? `${request.url}&instance_id_q=${this.instanceId}`
        : `${request.url}?instance_id_q=${this.instanceId}`;
      return request.clone({
        url: urlWithInstance,
        setHeaders: {
          Authorization: `Bearer ${token}`,
          "X-API-Key": `${this.authService.currentUserValue['x_api_token']}`,
          "X-Instance-Id": `${this.instanceId}`,
        }
      });
    }
    return request;
  }

  private handleError(error: any): Observable<never> {
    this.authService.logout();
    // this.alert.error_alert("Session has expired! Please re-login!");
    alert('Session has expired! Please re-login!')
    return EMPTY;
  }
}